module.exports = __webpack_public_path__ + "img/Technology Icon - white.de5895f1.svg";